<template>
  <footer class="h5 h5-esign-footer-wrapper">
    <!-- 服务热线 start -->
    <div class="about-us">
      <ul class="h5-hotline-wrapper">
        <li v-for="(item, index) in hotline" :key="index" class="item-wrapper">
          <a :href="item.url" :class="`item item-${item.id}`">
            <i class="icon" :style="item.iconUrl ? { backgroundImage: `url(${item.iconUrl})` } : {}" />
            <span :class="`desc desc-${item.id}`">{{ item.desc }}：</span>{{ item.title }}</a
          >
        </li>

        <!-- 其他社交软件联系方式 start -->
        <li class="item-wrapper other-line-wrapper" id="footup">
          <div class="other-line-title">关注我们</div>
          <div class="other-line">
            <div
              v-for="(item, index) in otherLine"
              :key="index"
              class="ol-item"
              @mouseover="handleMouseover(item.id)"
              @mouseout="handelMouseout()"
              @click="handleClick(item.id)"
            >
              <div class="ol-icon" :title="item.title"><img :src="current === item.id ? item.activeImgUrl : item.imgUrl" /></div>
              <div v-show="current === item.id" class="ol-code" @mouseover="handleMouseover(item.id)" @mouseout="handelMouseout()">
                <img :src="item.code" />
              </div>
            </div>
          </div>
        </li>
        <!-- 其他社交软件联系方式 end -->
      </ul>
    </div>
    <!-- 服务热线 end -->
    <div class="page-bottom">
      <div class="friend-link">
        友情链接:
        <a target="_blank" v-for="item in friendLink" :key="item.url" :href="item.url" class="link-item" rel="nofollow">{{ item.title }}</a>
      </div>
      <!-- 备案号 -->
      <div class="row">
        Copyright © 2021 杭州天谷信息科技有限公司版权所有. 增值电信业务经营许可证浙B2-20180376号 浙ICP备11026113号-4
        浙公网安备33010602010810号
      </div>
      <!-- 服务协议 -->
      <div class="agreement-link">
        <a v-for="link in agreementLink" :key="link.url" class="link" :href="link.url" rel="nofollow">{{ link.title }}</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    hotline: {
      type: Array,
      default() {
        return []
      },
    },
    otherLine: {
      type: Array,
      default() {
        return []
      },
    },
    agreementLink: {
      type: Array,
      default() {
        return []
      },
    },
    siteConfigBanquan: {
      type: String,
      default: '',
    },
    friendLink: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      current: '',
      timer: null,
    }
  },
  methods: {
    handleClick(id) {
      this.current = id
    },
    handleMouseover(current) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.current = current
    },
    handelMouseout() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.current = ''
      }, 300)
    },
  },
}
</script>

<style lang="less" scoped>
@base-scale: calc((100vw / 375));
.hotline-wrapper,
.h5-hotline-wrapper {
  .icon {
    display: inline-block;
    width: calc(@base-scale*11);
    height: calc(@base-scale*11);
    margin-right: calc(@base-scale*4.5);
    vertical-align: -0.1em;
  }
  .item-kefu-tel,
  .item-sale-tel {
    .icon {
      background: url('../../../assets/images/new-footer/icon-grey-tel.png') no-repeat center;
      background-size: 100%;
    }
  }
  .item-business-mail {
    .icon {
      background: url('../../../assets/images/new-footer/icon-handshake.png') no-repeat center;
      background-size: 100%;
    }
  }
  .item-ceo-mail {
    .icon {
      background: url('../../../assets/images/new-footer/icon-mail.png') no-repeat center;
      background-size: 100%;
    }
  }
}
.other-line {
  .ol-icon {
    width: calc(@base-scale*32);
    height: calc(@base-scale*32);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .ol-code {
    position: absolute;
    width: calc(@base-scale*132);
    height: calc(@base-scale*132);
    background: #fff;
    top: calc(@base-scale*40);
    &::before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: calc(@base-scale* (-7));
      left: calc(@base-scale*7);
      border: calc(@base-scale*6) solid transparent;
      border-top: 0;
      border-bottom: calc(@base-scale*7) solid #fff;
    }
    img {
      width: 100%;
    }
  }
}

.h5-esign-footer-wrapper {
  width: 100%;
  padding: calc(@base-scale*32) 0 calc(@base-scale*40);
  background: #242424;
}

.h5-hotline-wrapper {
  width: 100%;
  padding: 0 calc(@base-scale*15.5) calc(@base-scale*45) calc(@base-scale*15.5);

  .item-wrapper {
    width: 100%;
    padding: calc(@base-scale*10) calc(@base-scale*6);
    margin-bottom: calc(@base-scale*7);
    font-size: calc(@base-scale*12);
    color: #999;
    line-height: calc(@base-scale*17);
    border: 1px solid #4e4e4e;
    text-align: center;
  }
  .desc {
    font-size: calc(@base-scale*12);
    font-weight: 400;
    color: #999;
    line-height: calc(@base-scale*19.6);
  }
  .item {
    display: inline-block;
    width: calc(@base-scale*200);
    font-size: calc(@base-scale*12);
    font-weight: 600;
    color: #fff;
    line-height: calc(@base-scale*16.9);
    text-align: left;
  }
  .other-line-wrapper {
    border: none;
  }
  .other-line-title {
    margin-bottom: calc(@base-scale*17);
  }
  .other-line {
    position: relative;
    display: flex;
    justify-content: space-evenly;
  }
}

.page-bottom {
  width: 100%;
  text-align: center;
  color: rgba(153, 153, 153, 1);
  line-height: calc(@base-scale*16.8);
  font-weight: 400;
  background: rgba(51, 51, 51, 1);
  padding: calc(@base-scale*21) calc(@base-scale*25.5) calc(@base-scale*40);
  .friend-link {
    -webkit-text-size-adjust: none;
    font-size: calc(@base-scale*12);
    overflow: hidden;
    .link-item {
      font-size: calc(@base-scale*12);
      &::after {
        content: ' | ';
      }
      &:last-child {
        &::after {
          content: '';
        }
      }
    }
    a:hover {
      color: #fff;
    }
  }
  .row {
    -webkit-text-size-adjust: none;
    font-size: calc(@base-scale*12);
    margin: calc(@base-scale*12) 0 calc(@base-scale*12);
  }
  .link {
    color: #999;
    font-size: calc(@base-scale*12);
    &::after {
      content: ' | ';
    }
    &:last-child {
      &::after {
        content: '';
      }
    }
  }
}
</style>
